import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDeleteReview } from '../../hooks/useAlbumReviews';
import AdminDeleteButton from '../../../../components/button/AdminDeleteButton';
import { useNavigateWithScrollMemory } from '../../../../hooks/useNavigateWithScrollMemory';
import { Link, useLocation } from 'react-router-dom';
import ReviewerProfile from '../../../../components/common/ReviewerProfile';
import { useUserStore } from '../../../../stores/userStore';
import { getPageTypeFromPath } from '../../../../lib/gaParams';
import { trackUserProfileClick } from '../../../../lib/gaEvents';

const UserReviewItemHeader = ({ review, albumSource: albumSourceProp, sourceId: sourceIdProp }) => {
  const params = useParams();
  const albumSource = albumSourceProp ?? params.albumSource;
  const sourceId = sourceIdProp ?? params.sourceId;
  const { user } = useUserStore();
  const isAdmin = useUserStore((state) => state.isAdmin);
  const location = useLocation();
  const deleteReviewMutation = useDeleteReview(albumSource, sourceId);
  const navigateWithScrollMemory = useNavigateWithScrollMemory();

  if (!review) return null;

  const handleClick = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      e.stopPropagation();
      trackUserProfileClick(
        {
          contentName: review.user.nickname,
          pageType: getPageTypeFromPath(location.pathname),
        },
        user,
      );
      navigateWithScrollMemory(`/users/${encodeURIComponent(review.user.nickname)}`);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: { xs: 2, md: 2.5 },
      }}
    >
      <Link
        to={`/users/${encodeURIComponent(review.user.nickname)}`}
        onClick={handleClick}
        style={{
          flex: '1 1 auto',
          minWidth: 0,
          maxWidth: '100%',
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        <ReviewerProfile
          imageUrl={review.user.profileImageUrl}
          name={review.user.nickname}
          rating={review.rating}
          grade={review.user.grade}
        />
      </Link>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, lg: 0 } }}>
        {isAdmin && user && user.id !== review.user.id && (
          <AdminDeleteButton
            variant="small"
            onDelete={() =>
              deleteReviewMutation.mutate({ albumId: review.albumId, reviewId: review.id })
            }
          />
        )}
      </Box>
    </Box>
  );
};

export default UserReviewItemHeader;
